module.exports = "table thead tr td {\n  border-top: 0; }\n"